import React from 'react';

import generalIcons from '../../../assets/icons/grouped/general-icons.svg';
import styles from './Icon.module.css'
import {cn} from "../../../utils/cn.ts";

type IconType = 'general' | 'navigation'

interface Props {
    name: string
    width?: number
    height?: number
    color?: string
    type?: IconType
    stroke?: string
    onClick?: (value?: any) => void
    style?: React.CSSProperties
}

export const Icon: React.FC<Props & React.HTMLAttributes<HTMLOrSVGElement>> = ({
                                                                                   stroke,
    name,
    color,
    height,
    width,
    className,
    onClick,
    style,
}) => {
    const mainStyles = {
        width: width ? `${width}px`  : undefined,
        height: height ? `${height}px` : undefined,
        fill: color,
        stroke,
    };

    return (
        <svg className={cn(styles.icon, className)} style={{...mainStyles, ...style}} onClick={onClick ? onClick : () => {}}>
            <use href={`${generalIcons}#${name}`} />
        </svg>
    );
};